import { useState } from "react";
import "../../assets/Styles/EditProfile.css";
import { Link, useNavigate } from "react-router";
import { useEffect } from "react";
import { useHeaderData } from "../../context/HeaderContext";
import img1 from "../../assets/Images/Bitmap (1).png";
import { Camera } from "lucide-react";
import { Snackbar } from "../../utils/snackbar";
import { editprofile } from "../../services/Mainservice";

const Editprofile = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [error, seterror] = useState();
  const [loading, setloading] = useState(false);

  const [success, setsuccess] = useState();
  const [preview, setPreview] = useState();
  const [image, setImage] = useState();
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const { updateHeaderData } = useHeaderData();
  const profiledata = JSON.parse(localStorage.getItem("Data"));
  useEffect(() => {
    setData({
      email: profiledata.email,
      name: profiledata.fullName,
      profile_pic: profiledata.image,
      number: profiledata.mobilenumber,
    });
  }, []);

  const handleClose = (event, reason) => {
    setOpen(false);
  };
  const handleClose2 = (event, reason) => {
    setOpen2(false);
  };

  const handlechange = (e) => {
    const { name, value } = e.target;
    setData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const imagehandle = (e) => {
    if (e.target && e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setImage(file);
      setPreview(URL.createObjectURL(e.target.files[0]));
    } else {
      console.log("No file selected");
    }
  };

  const handleEdit = async () => {
    setloading(true);
    try {
      const editdata = await editprofile(data, image);
      profiledata.fullName = editdata.data.user.fullName;
      profiledata.image = editdata.data.user.image;
      profiledata.mobilenumber = editdata.data.user.mobilenumber;
      localStorage.setItem("Data", JSON.stringify(profiledata));
      setloading(false);

      setsuccess(editdata.data.message);
      setOpen2(true);
    } catch (error) {
      setloading(false);

      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
      seterror(error.message);
      setOpen(true);
    }
  };
  console.log(data);

  return (
    <>
      <div className="profileoptions">
        <li>
          <Link to="/Profile">Profile Info</Link>
        </li>
        <li className="active_profile">
          <Link to="/EditProfile">Update Profile</Link>
        </li>
        <li>
          <Link to="/ChangePassword">Change Password</Link>
        </li>
      </div>

      <div className="editdata">
        <div className="edit_profileimg">
          {preview ? (
            <img src={preview} alt="profile" className="editprofile_img" />
          ) : (
            <img
              src={data.profile_pic}
              // src={img1}
              alt="editprofile_image"
              className="editprofile_img"
            />
          )}

          <input
            type="file"
            id="file"
            accept="image/*"
            onChange={imagehandle}
            name="profile_pic"
          />
          <label htmlFor="file" id="uploadbtn">
            <Camera className="edit_cameraicn" style={{ cursor: "pointer" }} />
          </label>
        </div>

        <div className="edit_input">
          <label className="Auth_label">Username</label>
          <br />

          <input
            onChange={handlechange}
            name="name"
            type="text"
            className="Auth_input"
            placeholder="Name"
            minLength={1}
            maxLength={30}
            value={data.name}
            required
          />
        </div>
        <div className="edit_input">
          <label className="Auth_label">Phone Number</label>
          <br />

          <input
            onChange={handlechange}
            name="number"
            style={{ outline: "none" }}
            type="number"
            placeholder="453627819"
            className="Auth_input"
            value={data.number}
          />
        </div>
        <div className="edit_input">
          <label className="Auth_label">Email</label>
          <br />

          <input
            onChange={handlechange}
            name="email"
            style={{ outline: "none" }}
            type="email"
            placeholder="Email"
            className="Auth_input"
            minLength={10}
            maxLength={50}
            value={data.email}
          />
        </div>

        <button className="edit_button" disabled={loading} onClick={handleEdit}>
          {loading ? "Loading...." : "Save"}
        </button>
        <Snackbar
          open={open}
          severity="error"
          onclose={handleClose}
          message={error}
        />
        <Snackbar
          open={open2}
          severity="success"
          onclose={handleClose2}
          message={success}
        />
      </div>
    </>
  );
};
export default Editprofile;
